import { ThesaurusOfflineDataFetcher } from '@skinsoft/data-store'
import { EntityDataStore } from '@skinsoft/entity-data-store'
import { Observable } from 'rxjs'
import { identifer } from './selectors'

export interface Thesaurus {
    id: string
}

export class ThesaurusDataStore extends EntityDataStore<Thesaurus> {
    public static getInstance() {
        if (!ThesaurusDataStore.instance) {
            ThesaurusDataStore.instance = new ThesaurusDataStore()
        }

        return ThesaurusDataStore.instance
    }

    public static install(Vue) {
        Vue.prototype.$thesaurusDataStore = ThesaurusDataStore.getInstance()
    }

    private static instance: ThesaurusDataStore = null as any

    constructor() {
        super('thesaurus', ['thesaurus'])
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ThesaurusOfflineDataFetcher('thesaurus')
    }

    public fetchOneByIdentifier(identifier: string): Observable<Thesaurus> {
        if (window.navigator.onLine) {
            const uri = `${this.endpoint}/identifier/${identifier}`
            return this.proxy.fetch(uri, undefined, 'GET')
        } else {
            return this.fetchOneFromPredicate(thesaurus => identifer(thesaurus) === identifier)
        }
    }
}
